export const environment = {
  production: true,
  isMaintenance: false,
  INNOVATE_API: 'https://edgeapi.innovatemr.net/api/v1/',
  INNOVATE_API_V2: 'https://edgeapi.innovatemr.net/api/v2/',
  newBEHost: 'https://supplier.innovatemr.net/api/v2/',
  pointClubDomain: 'https://prod-pc-node.pointclub.com/',
  surveyFlow_Backend: 'https://surveyflow-api.innovatemr.net/api/v1/',
  ROUTER_API: 'https://routerapi.innovatemr.net/api/v1/',
  questionKeys: ['AGE', 'GENDER', 'ZIPCODES', 'EDUCATION', 'ETHNICITY', 'REGION', 'STATE', 'INCOME', 'EMPLOYMENT', 'CORE_ACCULTURATION_0001','DMA_CODE','DMA_NAME'],
  questionIds: [1, 2, 3, 4, 5, 7, 8, 13, 2437, 2438, 2439, 3434],
  sampleChainApiUrl: 'https://prod.rtymgt.com/api/v3/respondents/',
  // Sample Chain
  sampleChain: {
    secretKey: "93f02271-e4df-4a31-8af8-5def143e626e",
    privateKey: "c0ae1588-19ef-46ee-a249-d44fb647670f"
  },
  opinionRoute: {
    eventId: 'SR_2024'
  },
  HOSupplierCode : [1196],
  'DFIQ_S2S_API_ENABLED' : true,
  secretKeyToEncDcryPayload: 'innovateProduction',
  VERISOUL: {
    ENV: 'prod',
    PROJECT_ID: 'bf66a48f-c05d-4318-9329-579881b6010a',
    CUSTOM_DOMAIN: 'verfing.innovatemr.net'
  }
};